<div class="container-xl mt-3 mt-md-5">
  <div class="row mb-4 d-flex">
    <div class="col text-center mt-3" >
      <h3 *ngIf="!onHomePage">{{ page_title }} {{ location_string }}</h3>
    </div>
  </div>
  <div class="row mb-5 mb-5">
    <ng-container *ngFor="let venue of venues" >
      <ng-container *ngIf="show_services === false || (show_services === true && (venue?.categories?.length > 0 || venue?.servies?.length > 0))">
        <div class="col-12 mb-4">
          <div class="row align-items-center venue_container">
            <div [class.col-6]="show_services === false" [class.col-12]="show_services === true" class="col-md-3 align-self-start" style="padding: 0;">
              <div 
                class="venue-logo-container" 
                [ngStyle]="{'background-image': 'url(' +venue.banner_url + ')',
                'background-size': 'cover',
                'background-repeat': 'no-repeat',
                'background-position': 'center center'}"
                >
                <img [src]="venue.logo_url" [alt]="venue.name">
                <!-- <h4>{{ venue.name }}</h4> -->
              </div>
            </div>
            <div [class.col-6]="show_services === false" [class.col-12]="show_services === true" class="col-md-9">
              <div class="row">
                <div class="col-12">
                  <table class="table venue-details">
                    <tr>
                      <th class="border-top-0 d-flex align-items-center justify-content-between">
                        {{ venue.name }} 
                        <a [routerLink]="'/venue/' + venue.slug" class="btn btn-outline-primary btn-sm float-right book-button">
                          View
                        </a>
                    </th>
                    </tr>
                    <tr>
                      <td>{{ venue.address | replace:'\\n':', ':true }}</td>
                    </tr>
                    <!-- <tr *ngIf="venue.rating_count > 0">
                      <td class="border-top-0 mt-n2 pt-0">
                        <i class="fas fa-star"></i> {{ venue.average_rating }} ({{ venue.rating_count }})
                      </td>
                    </tr> -->
                  </table>
                </div>
                <div class="col-12 col-md-4 d-flex align-items-center justify-content-center mr-auto mr-md-0">
                  <div>
                    
                  </div>
                </div>
              </div>
              <ng-container *ngIf="show_services === true">
                <div class="row">
                  <div class="col">
                    <table class="table table-sm">
                      <tbody>
                        <ng-container *ngFor="let category of venue.categories">
                          <ng-container *ngIf="category.services.length > 0">
                            <tr>
                              <th class="border-top border-bottom">{{ category.name }}</th>
                            </tr>
                            <ng-container *ngIf="hasVisibleServices(category.services); else noServices">
                              <tr *ngFor="let service of category.services">
                                <td class="border-top-0" *ngIf="service.display">
                                  <div class="row align-items-center">
                                    <div class="col-12 col-md-8">
                                      {{ service.name }}
                                    </div>
                                    <div class="col-8 col-md-2">
                                      <div class="row">
                                        <div class="col-5 col-md-12"><small>{{ service.price | currency}}</small></div>
                                        <div class="col-7 col-md-12"><small>{{ service.time_taken }}</small></div>
                                      </div>
                                    </div>
                                    <div class="col-4 col-md-2">
                                      <a [routerLink]="'/venue/'+venue.slug+'/book-appointment/' + service.id" class="btn btn-outline-primary btn-sm book-button">
                                        <span (click)="setActiveVenue(venue, $event)">Book Now</span>
                                      </a>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </ng-container>
                          </ng-container>
                          <!-- No Services -->
                          <ng-template #noServices>
                            <tr>
                              <td class="text-muted">
                                No services available at the moment for {{category.name}}
                              </td>
                            </tr>
                          </ng-template>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-container>


            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="venues.length === 0">
      <div class="col-12 mb-4">
        <h5 class="montserrat-regular">{{ no_results }}</h5>
      </div>
    </ng-container>
  </div>
</div>